import Model from 'mixins/model';

export default class MatchModel extends Model {
    constructor() {
        super();
    }
    update(data) {
        const {
            startHour,
            competition,
            competitionShort,
            icon,
            isLive,
            liveMinute,
            homeTeam,
            homeLogo,
            homeScore,
            awayTeam,
            awayLogo,
            awayScore,
            banner,
            calendarLinks,
            sponsors,
        } = data;

        this.set('startHour', startHour);
        this.set('competition', competition);
        this.set('competitionShort', competitionShort);
        this.set('icon', icon);
        this.set('isLive', isLive);
        this.set('liveMinute', liveMinute);
        this.set('homeTeam', homeTeam);
        this.set('homeLogo', homeLogo);
        this.set('homeScore', homeScore);
        this.set('awayTeam', awayTeam);
        this.set('awayLogo', awayLogo);
        this.set('awayScore', awayScore);
        this.set('banner', banner);
        this.set('links', calendarLinks);
        this.set('sponsors', sponsors);
    }
    static fromJSON(data) {
        const {
            startHour,
            competition,
            competitionShort,
            icon,
            isLive,
            liveMinute,
            homeTeam,
            homeLogo,
            homeScore,
            awayTeam,
            awayLogo,
            awayScore,
            banner,
            calendarLinks,
            sponsors,
        } = data;
        const matchModel = new MatchModel();

        matchModel.set('startHour', startHour);
        matchModel.set('competition', competition);
        matchModel.set('competitionShort', competitionShort);
        matchModel.set('icon', icon);
        matchModel.set('isLive', isLive);
        matchModel.set('liveMinute', liveMinute);
        matchModel.set('homeTeam', homeTeam);
        matchModel.set('homeLogo', homeLogo);
        matchModel.set('homeScore', homeScore);
        matchModel.set('awayTeam', awayTeam);
        matchModel.set('awayLogo', awayLogo);
        matchModel.set('awayScore', awayScore);
        matchModel.set('banner', banner);
        matchModel.set('links', calendarLinks);
        matchModel.set('sponsors', sponsors);

        return matchModel;
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/MatchModel.js